import { createStyles, makeStyles, Popover, Theme, Typography } from '@material-ui/core';
import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { mainTheme } from '../Theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
      maxWidth: '500px'
    },
    icon: {
      color: mainTheme.TemplateColor.Primary,
    },
    root: {
      display: 'flex',
    }
  }),
);

interface HelpIconPopoverProps {
  iconClassName?: string;
  fontSize?: 'inherit' | 'default' | 'small' | 'large';
}

export const HelpIconPopover: React.FC<HelpIconPopoverProps> = (props) => {
    
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        className={`${props.iconClassName} ${classes.root}`}
      >
        <InfoIcon 
          className={classes.icon}
          fontSize={props.fontSize}
        />
      </Typography>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus={true}
      >
        
        {props.children}
      </Popover>
    </>
  );
};

export default HelpIconPopover;